import AVATAR1 from "../assets/avatars/avatar1.jpg";
import AVATAR2 from "../assets/avatars/avatar2.jpg";
import AVATAR3 from "../assets/avatars/avatar3.jpg";
import AVATAR4 from "../assets/avatars/avatar4.jpg";

export const TestimonialsData = [
  {
    id: 1,
    avatar: AVATAR1,
    name: "client1",
    reviewKey: "review1",
  },
  {
    id: 2,
    avatar: AVATAR2,
    name: "client2",
    reviewKey: "review2",
  },
  {
    id: 3,
    avatar: AVATAR3,
    name: "client3",
    reviewKey: "review3",
  },
  {
    id: 4,
    avatar: AVATAR4,
    name: "client4",
    reviewKey: "review4",
  },
];
